import { DropAlert } from '../drops/DropAlert'
import { DropPaper } from '../drops/DropPaper'
import { Input, Select, SelectItem } from '@nextui-org/react'
import { inputStyles, selectStyles } from '../common/styles'
import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { formatCurrency, tokenSortFunc } from '../helpers/FormatLinks'
import { Alert } from '@mui/material'
import Link from '../common/util/input/Link'

export const AirdropAmountEditor = ({
    airdropCurrency,
    setAirdropCurrency,
    holderCurrencyMin,
    holderCurrencyMax,
    setHolderCurrencyMin,
    setHolderCurrencyMax,
    currencies,
    fees,
}) => {
    const { t } = useTranslation('common')

    useEffect(() => {}, [
        holderCurrencyMin.price,
        holderCurrencyMax.price,
        airdropCurrency.price,
    ])

    return (
        <DropPaper
            id={'DropAmountEditor'}
            title={t('airdrops.token_details')}
            error={
                holderCurrencyMin.price > holderCurrencyMax.price > 0 &&
                parseInt(holderCurrencyMax.price) !== 0
            }
        >
            <div className="my-auto">
                {t('airdrops.select_token_to_airdrop')}
            </div>
            <div>
                <div className="flex flex-row my-5 md:gap-4 gap-2">
                    <div className="w-full">
                        <Input
                            size="sm"
                            classNames={{
                                ...inputStyles,
                            }}
                            variant="faded"
                            label={t('airdrops.amount_to_airdrop')}
                            placeholder="0"
                            defaultValue={airdropCurrency.price}
                            required={true}
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            isInvalid={airdropCurrency.price < 0 ? true : false}
                            onChange={(e) => {
                                const temp = {}
                                temp.currency = airdropCurrency.currency
                                temp.contract = airdropCurrency.contract
                                temp.price = Math.max(0, e.target.value)
                                setAirdropCurrency(temp)
                            }}
                        />
                    </div>
                    <div className="w-full">
                        <Select
                            size="sm"
                            scrollShadowProps={{ hideScrollBar: false }}
                            id="DropdownField10"
                            variant="faded"
                            placeholder={t('drops.select_a_currency')}
                            className="w-full"
                            classNames={{
                                ...selectStyles,
                            }}
                            defaultSelectedKeys={
                                new Set([
                                    airdropCurrency.currency !==
                                    '8,USD,USD,eosio.token'
                                        ? airdropCurrency.currency +
                                          ',' +
                                          airdropCurrency.contract
                                        : '8,WAX,USD,eosio.token',
                                ])
                            }
                            label={t('search.currency')}
                            onChange={(e) => {
                                const temp = {}
                                temp['price'] = airdropCurrency.price
                                const split = e.target.value.split(',')
                                temp['currency'] =
                                    split[0] + ',' + split[1] + ',' + split[2]
                                temp['contract'] = split[3]
                                setAirdropCurrency(temp)
                            }}
                        >
                            {currencies.sort(tokenSortFunc).map((currency) =>
                                currency.label !== 'USD' ? (
                                    <SelectItem
                                        key={
                                            currency.symbol +
                                            ',' +
                                            currency.label +
                                            ',' +
                                            currency.contract
                                        }
                                        value={
                                            currency.symbol +
                                            ',' +
                                            currency.label +
                                            ',' +
                                            currency.contract
                                        }
                                    >
                                        {`${currency.label} (${currency.contract})`}
                                    </SelectItem>
                                ) : null,
                            )}
                        </Select>
                    </div>
                </div>
            </div>

            <DropAlert condition={airdropCurrency.price > 0} severity="warning">
                {t('airdrops.this_transfers_x_and_y_to_wufclaimtool', {
                    x: formatCurrency(
                        airdropCurrency.price,
                        parseInt(airdropCurrency.currency.split(',')[0]),
                        true,
                        airdropCurrency.currency.split(',')[1],
                    ),
                    y: fees
                        ? formatCurrency(
                              fees.split(' ')[0],
                              fees.split(' ')[0].split('.')[1].length,
                              true,
                              fees.split(' ')[1],
                          )
                        : '50000000.0000 WUF',
                })}
            </DropAlert>
            <div className="mt-4">{t('airdrops.select_token_to_hold')}</div>

            <div>
                <div className="flex flex-row my-5 md:gap-4 gap-2">
                    <div className="w-full">
                        <Input
                            size="sm"
                            classNames={{
                                ...inputStyles,
                            }}
                            variant="faded"
                            label={t('airdrops.min_amount_to_hold')}
                            placeholder="0"
                            defaultValue={holderCurrencyMin.price}
                            required={true}
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            isInvalid={
                                holderCurrencyMin.price < 0 ? true : false
                            }
                            onChange={(e) => {
                                const temp = {}
                                temp.price = Math.max(0, e.target.value)
                                temp.currency = holderCurrencyMin.currency
                                temp.contract = holderCurrencyMin.contract
                                setHolderCurrencyMin(temp)
                            }}
                        />
                    </div>
                    <div className="w-full">
                        <Input
                            size="sm"
                            classNames={{
                                ...inputStyles,
                            }}
                            variant="faded"
                            label={t('airdrops.max_amount_to_hold')}
                            placeholder="0"
                            defaultValue={holderCurrencyMax.price}
                            required={true}
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            isInvalid={
                                holderCurrencyMax.price < 0 ? true : false
                            }
                            onChange={(e) => {
                                const temp = {}
                                temp.price = Math.max(0, e.target.value)
                                temp.currency = holderCurrencyMax.currency
                                temp.contract = holderCurrencyMax.contract
                                setHolderCurrencyMax(temp)
                            }}
                        />
                    </div>
                    <div className="w-full">
                        <Select
                            size="sm"
                            scrollShadowProps={{ hideScrollBar: false }}
                            id="DropdownField10"
                            variant="faded"
                            placeholder={t('drops.select_a_currency')}
                            className="w-full"
                            classNames={{
                                ...selectStyles,
                            }}
                            defaultSelectedKeys={
                                new Set([
                                    holderCurrencyMin.currency !==
                                    '8,USD,USD,eosio.token'
                                        ? holderCurrencyMin.currency +
                                          ',' +
                                          holderCurrencyMin.contract
                                        : '8,WAX,USD,eosio.token',
                                ])
                            }
                            label={t('search.currency')}
                            onChange={(e) => {
                                const tempMin = {}
                                const split = e.target.value.split(',')
                                tempMin.price = holderCurrencyMin.price
                                const tempMax = {}
                                tempMax.price = holderCurrencyMax.price
                                tempMin.currency =
                                    split[0] + ',' + split[1] + ',' + split[2]
                                tempMax.currency =
                                    split[0] + ',' + split[1] + ',' + split[2]
                                tempMin.contract = split[3]
                                tempMax.contract = split[3]
                                setHolderCurrencyMin(tempMin)
                                setHolderCurrencyMax(tempMax)
                            }}
                        >
                            {currencies.sort(tokenSortFunc).map((currency) =>
                                currency.label !== 'USD' ? (
                                    <SelectItem
                                        key={
                                            currency.symbol +
                                            ',' +
                                            currency.label +
                                            ',' +
                                            currency.contract
                                        }
                                        value={
                                            currency.symbol +
                                            ',' +
                                            currency.label +
                                            ',' +
                                            currency.contract
                                        }
                                    >
                                        {`${currency.label} (${currency.contract})`}
                                    </SelectItem>
                                ) : null,
                            )}
                        </Select>
                    </div>
                </div>
            </div>

            <DropAlert
                condition={
                    holderCurrencyMin.price > 0 && holderCurrencyMax.price === 0
                }
                severity="warning"
            >
                {t('airdrops.for_holders_of_x', {
                    x: formatCurrency(
                        holderCurrencyMin.price,
                        parseInt(holderCurrencyMin.currency.split(',')[0]),
                        true,
                        holderCurrencyMin.currency.split(',')[1],
                    ),
                })}
            </DropAlert>

            <DropAlert
                condition={
                    holderCurrencyMin.price > 0 && holderCurrencyMax.price > 0
                }
                severity="warning"
            >
                {t('airdrops.for_holders_of_x_snapshot_capped_at_y', {
                    x: formatCurrency(
                        holderCurrencyMin.price,
                        parseInt(holderCurrencyMin.currency.split(',')[0]),
                        true,
                        holderCurrencyMin.currency.split(',')[1],
                    ),
                    y: formatCurrency(
                        holderCurrencyMax.price,
                        parseInt(holderCurrencyMax.currency.split(',')[0]),
                        true,
                        holderCurrencyMax.currency.split(',')[1],
                    ),
                })}
            </DropAlert>

            <DropAlert
                condition={
                    !holderCurrencyMin?.price ||
                    (holderCurrencyMin.price > holderCurrencyMax.price > 0 &&
                        parseInt(holderCurrencyMax.price) !== 0)
                }
                severity="error"
            >
                {t('airdrops.min_amount_must_less_or_equal_to_max_amount')}
            </DropAlert>
            <Alert severity={'info'}>
                {t('airdrops.token_not_found_visit')}:{' '}
                <Link
                    href={
                        'https://discord.com/channels/806257237705621514/905191562990977024'
                    }
                    external={true}
                >
                    <div
                        className={'my-auto text-primary group-hover:underline'}
                    >
                        https://discord.com/channels/806257237705621514/905191562990977024
                    </div>
                </Link>
            </Alert>
        </DropPaper>
    )
}
